module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/97f7616dd4aac96ea35bab53a4b3642f.png";